import { AmplifilesClient } from "./api-client";
import {
  CreateCustomCaptionDto,
  CreateCustomCaptionResponseDto,
  UpdateCustomCaptionDto,
  UpdateCustomCaptionResponseDto,
  GetCustomCaptionsResponseDto,
  DeleteCustomCaptionResponseDto,
} from "@repo/api/caption";

export class CaptionApi {
  static async getCustomCaptions(
    teamExternalId: string,
  ): Promise<GetCustomCaptionsResponseDto> {
    const response = await AmplifilesClient.instance.get(
      `/team/${teamExternalId}/custom-caption`,
    );

    return GetCustomCaptionsResponseDto.parse(response.data);
  }

  static async createCustomCaption(
    teamExternalId: string,
    data: CreateCustomCaptionDto,
  ): Promise<CreateCustomCaptionResponseDto> {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/custom-caption`,
      data,
    );

    return CreateCustomCaptionResponseDto.parse(response.data);
  }

  static async updateCustomCaption(
    teamExternalId: string,
    captionExternalId: string,
    data: UpdateCustomCaptionDto,
  ): Promise<UpdateCustomCaptionResponseDto> {
    const response = await AmplifilesClient.instance.patch(
      `/team/${teamExternalId}/custom-caption/${captionExternalId}`,
      data,
    );

    return UpdateCustomCaptionResponseDto.parse(response.data);
  }

  static async deleteCustomCaption(
    teamExternalId: string,
    captionExternalId: string,
  ): Promise<DeleteCustomCaptionResponseDto> {
    const response = await AmplifilesClient.instance.delete(
      `/team/${teamExternalId}/custom-caption/${captionExternalId}`,
    );

    return DeleteCustomCaptionResponseDto.parse(response.data);
  }
}
